import React, { useEffect, useState } from 'react';
import { Button, Form, Grid, Header, Segment, Table, Icon, Modal, Input } from 'semantic-ui-react';
import Axios from 'axios';
import Constants from '../../../config/constants';
import { reactLocalStorage } from 'reactjs-localstorage';

const StaffPage = () => {
    const [staffList, setStaffList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [formStaff, setFormStaff] = useState({
        id: '',
        text: ''
    });

    useEffect(() => {
        fetchStaff();
    }, []);

    const fetchStaff = async () => {
        setLoading(true);
        try {
            const token = reactLocalStorage.get('token');
            const res = await Axios.get(`http://${Constants.url}:${Constants.port}/v1/snr/staff`, {
                headers: { Authorization: token }
            });
            if (res.data && res.data.code === 200) {
                setStaffList(res.data.data);
                // Also update the local storage cache!
                reactLocalStorage.set('staff_list', JSON.stringify(res.data.data));
            } else {
                console.error(res.data.message);
            }
        } catch (e) {
            console.error('Error fetching staff list:', e);
        }
        setLoading(false);
    };

    const handleOpenAddModal = () => {
        setIsEditMode(false);
        setFormStaff({
            id: '',
            text: ''
        });
        setModalOpen(true);
    };

    const handleOpenEditModal = (staff) => {
        setIsEditMode(true);
        setFormStaff({
            id: staff.key, // staff.key is mapped to the staff ID in GET /staff
            text: staff.text
        });
        setModalOpen(true);
    };

    const handleInputChange = (e) => {
        const { value } = e.target;
        setFormStaff(prev => ({ ...prev, text: value }));
    };

    const handleSaveStaff = async () => {
        if (!formStaff.text.trim()) {
            alert('กรุณากรอกชื่ออาจารย์แพทย์ / เจ้าหน้าที่');
            return;
        }

        const token = reactLocalStorage.get('token');
        try {
            if (isEditMode) {
                // Update
                const res = await Axios.put(`http://${Constants.url}:${Constants.port}/v1/snr/staff/${formStaff.id}`, { text: formStaff.text }, {
                    headers: { Authorization: token }
                });
                if (res.data && res.data.code === 200) {
                    setModalOpen(false);
                    fetchStaff();
                } else {
                    alert(res.data.message || 'Error updating staff member');
                }
            } else {
                // Create
                const res = await Axios.post(`http://${Constants.url}:${Constants.port}/v1/snr/staff`, { text: formStaff.text }, {
                    headers: { Authorization: token }
                });
                if (res.data && (res.data.code === 200 || res.data.code === 201)) {
                    setModalOpen(false);
                    fetchStaff();
                } else {
                    alert(res.data.message || 'Error creating staff member');
                }
            }
        } catch (e) {
            console.error('Error saving staff:', e);
            alert('เกิดข้อผิดพลาดในการบันทึกข้อมูล');
        }
    };

    const handleDeleteStaff = async (id, name) => {
        if (window.confirm(`ยืนยันการลบรายชื่ออาจารย์ "${name}"?`)) {
            const token = reactLocalStorage.get('token');
            try {
                const res = await Axios.delete(`http://${Constants.url}:${Constants.port}/v1/snr/staff/${id}`, {
                    headers: { Authorization: token }
                });
                if (res.data && res.data.code === 200) {
                    fetchStaff();
                } else {
                    alert(res.data.message || 'Error deleting staff member');
                }
            } catch (e) {
                console.error('Error deleting staff:', e);
                alert('เกิดข้อผิดพลาดในการลบข้อมูล');
            }
        }
    };

    return (
        <div style={{ display: 'flex', minHeight: '90vh', flexDirection: 'column' }}>
            <div style={{ flex: 1 }}>
                <Grid style={{ marginTop: '5.5em', padding: '0 30px' }}>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Segment color='teal' raised style={{ padding: '2em' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5em', borderBottom: '1px solid #eee', paddingBottom: '1em' }}>
                                    <Header as='h2' style={{ margin: 0 }}>
                                        <Icon name='doctor' color='teal' />
                                        <Header.Content>
                                            การจัดการรายชื่ออาจารย์แพทย์/เจ้าหน้าที่
                                            <Header.Subheader style={{ marginTop: '0.25em' }}>Staff Configuration</Header.Subheader>
                                        </Header.Content>
                                    </Header>
                                    <Button color='green' onClick={handleOpenAddModal}>
                                        <Icon name='plus circle' /> เพิ่มรายชื่อใหม่
                                    </Button>
                                </div>

                                <Table celled structured loading={loading}>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell style={{ width: '80px' }}>ID</Table.HeaderCell>
                                            <Table.HeaderCell>ชื่อ-นามสกุลอาจารย์แพทย์</Table.HeaderCell>
                                            <Table.HeaderCell style={{ width: '200px', textAlign: 'center' }}>การจัดการ</Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>

                                    <Table.Body>
                                        {staffList.map((staff) => (
                                            <Table.Row key={staff.key}>
                                                <Table.Cell>{staff.key}</Table.Cell>
                                                <Table.Cell>{staff.text}</Table.Cell>
                                                <Table.Cell style={{ textAlign: 'center' }}>
                                                    <div style={{ display: 'flex', gap: '5px', justifyContent: 'center', alignItems: 'center' }}>
                                                        <Button size='mini' color='blue' onClick={() => handleOpenEditModal(staff)}>
                                                            <Icon name='edit' /> แก้ไข
                                                        </Button>
                                                        <Button size='mini' color='red' onClick={() => handleDeleteStaff(staff.key, staff.text)}>
                                                            <Icon name='trash' /> ลบ
                                                        </Button>
                                                    </div>
                                                </Table.Cell>
                                            </Table.Row>
                                        ))}
                                        {staffList.length === 0 && !loading && (
                                            <Table.Row>
                                                <Table.Cell colSpan='3' style={{ textAlign: 'center' }}>ไม่พบข้อมูลรายชื่ออาจารย์แพทย์</Table.Cell>
                                            </Table.Row>
                                        )}
                                    </Table.Body>
                                </Table>
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>

            {/* Add / Edit Staff Modal */}
            <Modal open={modalOpen} onClose={() => setModalOpen(false)} size='small'>
                <Modal.Header>
                    <Icon name={isEditMode ? 'edit' : 'plus'} /> {isEditMode ? 'แก้ไขรายชื่อ' : 'เพิ่มรายชื่อใหม่'}
                </Modal.Header>
                <Modal.Content>
                    <Form>
                        <Form.Field required>
                            <label>ชื่อ-นามสกุลอาจารย์แพทย์</label>
                            <Input 
                                value={formStaff.text} 
                                onChange={handleInputChange} 
                                placeholder='ตัวอย่าง: นพ.ไชยยุทธ ธนไพศาล' 
                            />
                        </Form.Field>
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={() => setModalOpen(false)}>ยกเลิก</Button>
                    <Button color='green' onClick={handleSaveStaff}>
                        <Icon name='save' /> บันทึก
                    </Button>
                </Modal.Actions>
            </Modal>
        </div>
    );
};

export default StaffPage;
